'use client';

import * as React from 'react';

import type { VariantProps } from 'tailwind-variants';
import { tv } from 'tailwind-variants';

import { cn } from '@avodah-inc/ui/utils';

const messageVariants = tv({
  base: 'flex justify-center items-center w-fit py-2 pl-3 pr-16 border rounded-lg text-gray-900 relative',
  variants: {
    variant: {
      primary: 'bg-transparent border-gray-300',
      secondary: 'bg-secondary-50 border-secondary-200',
    },
  },
  defaultVariants: {
    variant: 'primary',
  },
});

export type MessageProps = {
  text: string;
  timestamp?: string;
} & React.HTMLAttributes<HTMLDivElement> &
  VariantProps<typeof messageVariants>;

export const Message = React.forwardRef<HTMLDivElement, MessageProps>(
  (props, ref) => {
    return (
      <div
        className={cn(
          messageVariants({
            variant: props.variant,
            className: props.className,
          }),
        )}
        ref={ref}
        {...props}
      >
        <p className="flex w-full">{props.text}</p>
        {props.timestamp ? (
          <span className="absolute bottom-1 right-2 text-xs text-gray-500">
            {props.timestamp}
          </span>
        ) : null}
      </div>
    );
  },
);

Message.displayName = 'Message';
